import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function ProjectTooltip(props: ContentTooltipProps): JSX.Element {
  // Remove the trailing textile image in the tooltip (this image is only used for setting the project card thumbnail)
  const description = props.content.description
    ? props.content.description.replace(TextileHelper.TRAILING_IMAGE, '')
    : props.content.description;

  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <User user={props.content.owner} label={Messages.owner()} urls={props.urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
